// extracted by mini-css-extract-plugin
export var activeTaskResourceItem = "ActiveTaskResourceItem-module--activeTaskResourceItem--2kciT";